import { Envs } from '@ae/envs';
import { Locale } from '@ae/i18n';

//-------------------------------------------------------
// Domains
//-------------------------------------------------------

export const beDomains: Record<Locale, string> = {
  [Locale.Nl]: 'https://www.ardennes-etape.be',
  [Locale.Fr]: 'https://fr.ardennes-etape.be',
  [Locale.En]: 'https://en.ardennes-etape.be',
  [Locale.De]: 'https://de.ardennes-etape.be',
};

export const foreignDomains: Record<Locale, string> = {
  [Locale.Nl]: 'https://www.ardennes-etape.nl',
  [Locale.Fr]: 'https://www.ardennes-etape.fr',
  [Locale.En]: 'https://www.ardennes-etape.co.uk',
  [Locale.De]: 'https://www.ardennes-etape.de',
};

//-------------------------------------------------------
// Legacy endpoints
//-------------------------------------------------------

export function getLegacyAuthEndpoint(
  url: string,
  apiEndpoint: string,
  language: Locale
) {
  const targetUrl = encodeURIComponent(url);
  return `${apiEndpoint}/auth/login/${Envs.keycloakId}/${language}?target=${targetUrl}`;
}

export function getLegacyLogoutEndpoint(url: string, apiEndpoint: string) {
  const targetUrl = encodeURIComponent(url);
  return `${apiEndpoint}/auth/logout?target=${targetUrl}`;
}
